'use strict';

if (process.env.NODE_ENV === "production") {
  module.exports = require("./utils.cjs.prod.js");
} else {
  module.exports = require("./utils.cjs.dev.js");
}
